import Vue from 'vue'
import Router from 'vue-router'
import i18n from './i18n.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // ****************************** LOGIN
    {
      path: '/login/:redirect?',
      name: 'login',
      component: () => import('./views/auth/Login.vue'),
      meta: {
        title: 'Login',
        auth: false
      }
    },

    // ****************************** HOME
    {
      path: '/',
      name: 'home',
      component: () => import('./views/home/Home.vue'),
      meta: {
        auth: true
      }
    },

    // ****************************** DASHBOARD
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('./views/dashboard/Dashboard.vue'),
      meta: {
        title: 'Dashboard',
        auth: true
      }
    },

    // ****************************** INVENTORY
    {
      path: '/inventory',
      name: 'inventory',
      component: () => import('./views/inventory/_inventorySection.vue'),
      meta: {
        title: 'Inventory',
        auth: true
      }
    },
    {
      path: '/inventory/factories',
      name: 'inventory-factories',
      component: () => import('./views/inventory/factories/_factories.vue'),
      meta: {
        title: 'Inventory :: Factories',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/fixed-assets',
      name: 'inventory-fixed-assets',
      component: () => import('./views/inventory/fixedAssets/_fixedAssets.vue'),
      meta: {
        title: 'Inventory :: Fixed Assets',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/fixed-asset-types',
      name: 'inventory-fixed-asset-types',
      component: () => import('./views/inventory/fixedAssetTypes/_fixedAssetTypes.vue'),
      meta: {
        title: 'Inventory :: Fixed Asset Types',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/product-types',
      name: 'inventory-product-types',
      component: () => import('./views/inventory/productTypes/_productTypes.vue'),
      meta: {
        title: 'Inventory :: Product Types',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/products',
      name: 'inventory-products',
      component: () => import('./views/inventory/products/_products.vue'),
      meta: {
        title: 'Inventory :: Products',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/raw-materials',
      name: 'inventory-raw-materials',
      component: () => import('./views/inventory/rawMaterials/_rawMaterials.vue'),
      meta: {
        title: 'Inventory :: Raw Materials',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/mixtures',
      name: 'inventory-mixtures',
      component: () => import('./views/inventory/mixtures/_mixtures.vue'),
      meta: {
        title: 'Inventory :: Mixtures',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/destructed-assets',
      name: 'inventory-destructed-assets',
      component: () => import('./views/inventory/destructedAssets/_destructedAssets.vue'),
      meta: {
        title: 'Inventory :: Destructed Assets',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/transfers',
      name: 'inventory-transfers',
      component: () => import('./views/inventory/transfers/_transfers.vue'),
      meta: {
        title: 'Inventory :: Transfers',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/receives',
      name: 'inventory-receives',
      component: () => import('./views/inventory/receives/_receives.vue'),
      meta: {
        title: 'Inventory :: Orders',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/inventory',
      name: 'inventory-inventory',
      component: () => import('./views/inventory/inventory/_inventory.vue'),
      meta: {
        title: 'Inventory :: Inventory',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/product-shortages',
      name: 'inventory-product-shortages',
      component: () => import('./views/inventory/productShortages/_productShortages.vue'),
      meta: {
        title: 'Inventory :: Product Shortages',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/product-near-expiries',
      name: 'inventory-product-near-expiries',
      component: () => import('./views/inventory/productNearExpiries/_productNearExpiries.vue'),
      meta: {
        title: 'Inventory :: Product Near Expiries',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/product-expired',
      name: 'inventory-product-expired',
      component: () => import('./views/inventory/productExpired/_productExpired.vue'),
      meta: {
        title: 'Inventory :: Product Expired',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/productions',
      name: 'inventory-productions',
      component: () => import('./views/inventory/productions/_productions.vue'),
      meta: {
        title: 'Inventory :: Productions',
        parentPath: '/inventory',
        auth: true
      }
    },
    {
      path: '/inventory/weight-auditor',
      name: 'inventory-weight-auditor',
      component: () => import('./views/inventory/weightAuditor/_weightAuditor.vue'),
      meta: {
        title: 'Inventory :: Weight Auditor',
        parentPath: '/inventory',
        auth: true
      }
    },

    // ****************************** ACCOUNTING
    {
      path: '/accounting',
      name: 'accounting',
      component: () => import('./views/accounting/_accounting.vue'),
      meta: {
        title: 'Accounting',
        auth: true
      }
    },
    {
      path: '/accounting/dollar-prices',
      name: 'accounting-dollar-prices',
      component: () => import('./views/accounting/dollarRates/_dollarRates.vue'),
      meta: {
        title: 'Accounting :: Dollar Prices',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/currency-exchanges',
      name: 'accounting-currency-exchanges',
      component: () => import('./views/accounting/currencyExchanges/_currencyExchanges.vue'),
      meta: {
        title: 'Accounting :: Currency Exchanges',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/banks',
      name: 'accounting-banks',
      component: () => import('./views/accounting/banks/_banks.vue'),
      meta: {
        title: 'Accounting :: Banks',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/banks/transactions',
      name: 'accounting-bank-transactions',
      component: () => import('./views/accounting/banks/transactions/_bankTransactions.vue'),
      meta: {
        title: 'Accounting :: Bank Transactions',
        parentPath: '/accounting/banks',
        auth: true
      }
    },
    {
      path: '/accounting/expenses-types',
      name: 'accounting-expenses-types',
      component: () => import('./views/accounting/expenseType/_expenseType.vue'),
      meta: {
        title: 'Accounting :: Expense Types',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/incomes-types',
      name: 'accounting-incomes-types',
      component: () => import('./views/accounting/incomeType/_incomeType.vue'),
      meta: {
        title: 'Accounting :: Income Types',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/main-cashiers',
      name: 'accounting-main-cashiers',
      component: () => import('./views/accounting/mainCashiers/_mainCashiers.vue'),
      meta: {
        title: 'Accounting :: Main Cashiers',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/main-cashiers/transactions',
      name: 'accounting-cashier-transactions',
      component: () => import('./views/accounting/mainCashiers/transactions/_cashierTransactions.vue'),
      meta: {
        title: 'Accounting :: Cashier Transactions',
        parentPath: '/accounting/main-cashier',
        auth: true
      }
    },
    {
      path: '/accounting/main-cashiers/debitCredit',
      name: 'accounting-cashier-debit-credit',
      component: () => import('./views/accounting/mainCashiers/debitCredit/_debitCredit.vue'),
      meta: {
        title: 'Accounting :: Cashier Debit & Credit Transactions',
        parentPath: '/accounting/main-cashier',
        auth: true
      }
    },
    {
      path: '/accounting/cashiers',
      name: 'accounting-cashiers',
      component: () => import('./views/accounting/cashiers/_cashiers.vue'),
      meta: {
        title: 'Accounting :: Cashiers',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/cash-transactions',
      name: 'accounting-cash-transactions',
      component: () => import('./views/accounting/cashTransactions/_cashTransactions.vue'),
      meta: {
        title: 'Accounting :: Cash Transactions',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/promo-cards',
      name: 'accounting-promo-cards',
      component: () => import('./views/accounting/promoCards/_promoCards.vue'),
      meta: {
        title: 'Accounting :: Promo Cards',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/promotions',
      name: 'accounting-promotions',
      component: () => import('./views/accounting/promotions/_promotions.vue'),
      meta: {
        title: 'Accounting :: Promotion',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/purchases',
      name: 'accounting-purchases',
      component: () => import('./views/accounting/purchases/_purchases.vue'),
      meta: {
        title: 'Accounting :: Purchases',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/incomes',
      name: 'accounting-incomes',
      component: () => import('./views/accounting/incomes/_incomes.vue'),
      meta: {
        title: 'Accounting :: Incomes',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/expenses',
      name: 'accounting-expenses',
      component: () => import('./views/accounting/expenses/_expenses.vue'),
      meta: {
        title: 'Accounting :: Expenses',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/taxes',
      name: 'accounting-taxes',
      component: () => import('./views/accounting/taxes/_taxes.vue'),
      meta: {
        title: 'Accounting :: Taxes',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/purchases-returns',
      name: 'accounting-purchases-returns',
      component: () => import('./views/accounting/purchasesReturns/_purchasesReturns.vue'),
      meta: {
        title: 'Accounting :: Purchase Returns',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/account-payable',
      name: 'accounting-account-payable',
      component: () => import('./views/accounting/accountPayable/_accountPayable.vue'),
      meta: {
        title: 'Accounting :: Account Payable',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/account-payable/statements',
      name: 'accounting-account-payable-statements',
      component: () => import('./views/accounting/accountPayable/statements/_payableStatements.vue'),
      meta: {
        title: 'Accounting :: Account Payable Statements',
        parentPath: '/account-payable',
        auth: true
      }
    },
    {
      path: '/accounting/account-payable/payments',
      name: 'accounting-account-payable-payments',
      component: () => import('./views/accounting/accountPayable/payments/_payments.vue'),
      meta: {
        title: 'Accounting :: Account Payable Payments',
        parentPath: '/account-payable',
        auth: true
      }
    },
    {
      path: '/accounting/commission-payable',
      name: 'accounting-commission-payable',
      component: () => import('./views/accounting/commissionPayable/_commissionPayable.vue'),
      meta: {
        title: 'Accounting :: Commission Payable',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/commission-payable/statements',
      name: 'accounting-commission-payable-statements',
      component: () => import('./views/accounting/commissionPayable/statements/_commissionStatements.vue'),
      meta: {
        title: 'Accounting :: Commission Payable Statements',
        parentPath: '/commission-payable',
        auth: true
      }
    },
    {
      path: '/accounting/account-receivable',
      name: 'accounting-account-receivable',
      component: () => import('./views/accounting/accountReceivable/_accountReceivable.vue'),
      meta: {
        title: 'Accounting :: Account Receivable',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/account-receivable/statements',
      name: 'accounting-account-receivable-statements',
      component: () => import('./views/accounting/accountReceivable/statements/_receivableStatements.vue'),
      meta: {
        title: 'Accounting :: Account Receivable Statements',
        parentPath: '/account-receivable',
        auth: true
      }
    },
    {
      path: '/accounting/account-receivable/receives',
      name: 'accounting-account-receivable-receives',
      component: () => import('./views/accounting/accountReceivable/receives/_receives.vue'),
      meta: {
        title: 'Accounting :: Account Receivable Receives',
        parentPath: '/account-receivable',
        auth: true
      }
    },
    {
      path: '/accounting/remittance-office',
      name: 'accounting-remittance-office',
      component: () => import('./views/accounting/remittances/_remittances.vue'),
      meta: {
        title: 'Accounting :: Remittance Office',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/remittance-office/transactions',
      name: 'accounting-remittance-office-transactions',
      component: () => import('./views/accounting/remittances/transactions/_remittanceTransactions.vue'),
      meta: {
        title: 'Accounting :: Remittance Transactions',
        parentPath: '/accounting/remittance-office',
        auth: true
      }
    },
    {
      path: '/accounting/stockholders',
      name: 'accounting-stockholders',
      component: () => import('./views/accounting/stockholders/_stockholders.vue'),
      meta: {
        title: 'Accounting :: Stockholders',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/dividends',
      name: 'accounting-dividends',
      component: () => import('./views/accounting/dividends/_dividends.vue'),
      meta: {
        title: 'Accounting :: Dividends',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/payrolls',
      name: 'accounting-payrolls',
      component: () => import('./views/accounting/payrolls/_payroll.vue'),
      meta: {
        title: 'Accounting :: Payrolls',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/payroll-details/:id',
      name: 'accounting-payroll-details',
      component: () => import('./views/accounting/payrolls/details/_payrollDetails.vue'),
      meta: {
        title: 'Accounting :: Payroll Details',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/sales',
      name: 'accounting-sales',
      component: () => import('./views/accounting/sales/_sales.vue'),
      meta: {
        title: 'Accounting :: Sales',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/sales-returns',
      name: 'accounting-sales-returns',
      component: () => import('./views/accounting/salesReturns/_salesReturns.vue'),
      meta: {
        title: 'Accounting :: Sales Returns',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/quotations',
      name: 'accounting-quotations',
      component: () => import('./views/accounting/quotations/_quotations.vue'),
      meta: {
        title: 'Accounting :: Quotations',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/purchases-fixed-asset',
      name: 'accounting-purchases-fixed-asset',
      component: () => import('./views/accounting/fixedPurchases/_fixedPurchases.vue'),
      meta: {
        title: 'Accounting :: Purchase Fixed Asset',
        parentPath: '/accounting',
        auth: true
      }
    },
    {
      path: '/accounting/purchases-return-fixed-asset',
      name: 'accounting-purchases-return-fixed-asset',
      component: () => import('./views/accounting/fixedPurchasesReturns/_fixedPurchasesReturns.vue'),
      meta: {
        title: 'Accounting :: Purchase Return Fixed Asset',
        parentPath: '/accounting',
        auth: true
      }
    },

    // ****************************** SUPPLIERS
    {
      path: '/suppliers',
      name: 'suppliers',
      component: () => import('./views/suppliers/_suppliers.vue'),
      meta: {
        title: 'Suppliers',
        auth: true
      }
    },

    // ***************************** USER PROFILE
    {
      path: '/profile',
      name: 'profile',
      component: () => import('./views/userProfile/_userProfile.vue'),
      meta: {
        title: 'Profile',
        auth: true
      }
    },

    // ****************************** STAFF
    {
      path: '/staff',
      name: 'staff',
      component: () => import('./views/staff/_staffSection.vue'),
      meta: {
        title: 'Staff',
        auth: true
      }
    },
    {
      path: '/staff/staff',
      name: 'staff-list',
      component: () => import('./views/staff/staff/_staff.vue'),
      meta: {
        title: 'Staff :: Staff',
        parentPath: '/staff',
        auth: true
      }
    },
    {
      path: '/staff/salesmen',
      name: 'salesmen',
      component: () => import('./views/staff/salesmen/_salesmen.vue'),
      meta: {
        title: 'Staff :: Salesmen',
        parentPath: '/staff',
        auth: true
      }
    },
    {
      path: '/staff/system-logs',
      name: 'system-logs',
      component: () => import('./views/staff/systemLogs/_systemLogs.vue'),
      meta: {
        title: 'Staff :: System Logs',
        parentPath: '/staff',
        auth: true
      }
    },

    // ****************************** CUSTOMERS
    {
      path: '/customers',
      name: 'customers',
      component: () => import('./views/customers/_customersSection.vue'),
      meta: {
        title: 'Customers',
        auth: true
      }
    },
    {
      path: '/customers/customers-groups',
      name: 'customers-groups',
      component: () => import('./views/customers/groups/_groups.vue'),
      meta: {
        title: 'Customers Groups',
        parentPath: '/customers',
        auth: true
      }
    },
    {
      path: '/customers/customers',
      name: 'customers-list',
      component: () => import('./views/customers/customers/_customers.vue'),
      meta: {
        title: 'Customers List',
        parentPath: '/customers',
        auth: true
      }
    },

    // ****************************** Reports
    {
      path: '/reports',
      name: 'reports',
      component: () => import('./views/reports/_reportsSection.vue'),
      meta: {
        title: 'Reports',
        auth: true
      }
    },
    {
      path: '/reports/total-inventories-report',
      name: 'total-inventories-report',
      component: () => import('./views/reports/totalInventories/_totalInventories.vue'),
      meta: {
        title: 'Report :: Total Inventories',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/total-product-shortages-report',
      name: 'total-product-shortages-report',
      component: () => import('./views/reports/totalProductShortages/_totalProductShortages.vue'),
      meta: {
        title: 'Report :: Total Product Shortages',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/total-product-near-expiries-report',
      name: 'total-product-near-expiries-report',
      component: () => import('./views/reports/totalProductNearExpiries/_totalProductNearExpiries.vue'),
      meta: {
        title: 'Report :: Total Product Near Expiries',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/total-product-expired-report',
      name: 'total-product-expired-report',
      component: () => import('./views/reports/totalProductExpired/_totalProductExpired.vue'),
      meta: {
        title: 'Report :: Total Product Expired',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/destructed-assets-report',
      name: 'destructed-assets-report',
      component: () => import('./views/reports/destructedAssets/_destructedAssets.vue'),
      meta: {
        title: 'Report :: Destructed Assets',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/productions-report',
      name: 'productions-report',
      component: () => import('./views/reports/productions/_productions.vue'),
      meta: {
        title: 'Report :: Productions',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/expenses-report',
      name: 'expenses-report',
      component: () => import('./views/reports/expenses/_expenses.vue'),
      meta: {
        title: 'Report :: Expenses',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/expenses-type-report',
      name: 'expenses-type-report',
      component: () => import('./views/reports/expensesType/_expensesType.vue'),
      meta: {
        title: 'Report :: Expenses',
        parentPath: '/reports',
        auth: true
      }
    },

    {
      path: '/reports/incomes-report',
      name: 'incomes-report',
      component: () => import('./views/reports/incomes/_incomes.vue'),
      meta: {
        title: 'Report :: Incomes',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/purchases-report',
      name: 'purchases-report',
      component: () => import('./views/reports/purchases/_purchases.vue'),
      meta: {
        title: 'Report :: Purchases',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/purchases-returns-report',
      name: 'purchases-returns-report',
      component: () => import('./views/reports/purchasesReturns/_purchasesReturns.vue'),
      meta: {
        title: 'Report :: Purchases Returns',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/sales-report',
      name: 'sales-report',
      component: () => import('./views/reports/sales/_sales.vue'),
      meta: {
        title: 'Report :: Sale',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/sales-returns-report',
      name: 'sales-returns-report',
      component: () => import('./views/reports/salesReturns/_salesReturns.vue'),
      meta: {
        title: 'Report :: Sales Returns',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/chart-of-accounts',
      name: 'reports-chart-of-accounts',
      component: () => import('./views/reports/chartOfAccounts/_chartOfAccounts.vue'),
      meta: {
        title: 'Accounting :: Chart of Accounts',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/general-journal-report',
      name: 'general-journal-report',
      component: () => import('./views/reports/generalJournal/_generalJournal.vue'),
      meta: {
        title: 'Report :: General Journal',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/general-ledger-report',
      name: 'general-ledger-report',
      component: () => import('./views/reports/generalLedger/_generalLedger.vue'),
      meta: {
        title: 'Report :: General Ledger',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/general-ledger-report/ledger-details',
      name: 'ledger-details',
      component: () => import('./views/reports/generalLedger/_ledgerDetails.vue'),
      meta: {
        title: 'Report :: Ledger Details',
        parentPath: '/reports/general-ledger-report',
        auth: true
      }
    },
    {
      path: '/reports/trial-balance',
      name: 'trial-balance',
      component: () => import('./views/reports/trialBalance/_trialBalance.vue'),
      meta: {
        title: 'Report :: Trail Balance',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/incomes-statement',
      name: 'incomes-statement',
      component: () => import('./views/reports/incomeStatement/_incomeStatement.vue'),
      meta: {
        title: 'Report :: Income Statement',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/balance-sheet',
      name: 'balance-sheet',
      component: () => import('./views/reports/balanceSheet/_balanceSheet.vue'),
      meta: {
        title: 'Report :: Balance Sheet',
        parentPath: '/reports',
        auth: true
      }
    },
    {
      path: '/reports/closing-entries',
      name: 'closing-entries',
      component: () => import('./views/reports/closingEntries/_closingEntries.vue'),
      meta: {
        title: 'Report :: Closing Entries',
        parentPath: '/reports',
        auth: true
      }
    },

    // ****************************** SETTINGS
    {
      path: '/preferences/system-features',
      name: 'system-features',
      component: () => import('./views/preferences/systemFeatures/_systemFeatures.vue'),
      meta: {
        title: 'Preferences :: System Features',
        parentPath: '/preferences',
        auth: true
      }
    },
    {
      path: '/preferences/system-configurations',
      name: 'system-configurations',
      component: () => import('./views/preferences/systemConfigurations/_systemConfigurations.vue'),
      meta: {
        title: 'Preferences :: System Configurations',
        parentPath: '/preferences',
        auth: true
      }
    },
    {
      path: '/preferences/outlets',
      name: 'preferences-outlets',
      component: () => import('./views/preferences/outlets/_outlets.vue'),
      meta: {
        title: 'Preferences :: Outlets',
        parentPath: '/preferences',
        auth: true
      }
    },
    {
      path: '/preferences/opening-balance',
      name: 'opening-balance',
      component: () => import('./views/preferences/openingBalance/_openingBalance.vue'),
      meta: {
        title: 'Preferences :: Opening Balance',
        parentPath: '/preferences',
        auth: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/about/About.vue'),
      meta: {
        title: 'About',
        auth: true
      }
    },
    {
      path: '*',
      name: '404',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/404/404.vue'),
      meta: {
        title: 'Not Found',
        auth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // if locale language is set, we try to translate the page title, and if
    // translation wasn't found, it wil ldefault to the to.meta.title string
    let currentLocale = localStorage.getItem('language')
    i18n.locale = currentLocale
    document.title = `KEENTECH - ${i18n.t(to.meta.title)}`
  } else {
    // if no title in the to.meta.title found, just display keentech
    document.title = 'KEENTECH'
  }

  // Remove trailing slash from url
  if (to.path !== '/' && to.path[to.path.length - 1] === '/') {
    next(to.path.slice(0, -1))
  } else {
    next()
  }
})

export default router
